<div bsModal #modal="bs-modal" class="modal fade release-note-form" tabindex="-1" role="dialog" aria-hidden="false">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title">{{ queryParams.modalTitle | translate }}</h4>
            </div>
            <div class="modal-body">
                <form [formGroup]="form" novalidate (ngSubmit)="submit(form.value, form.valid)">
                    <div class="row">
                        <div class="form-group offset-xs-4 col-xs-8">
                            <input formControlName="show" type="checkbox" id="show-on-support"/>
                            <label for="show-on-support">{{ 'Show Release Note on Support page' | translate }}</label>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-xs-4 release-note-form--thumbnails">
                            <div class="mr-t--md"></div>
                            <div class="img-space">
                                <ng-container *ngIf="isImageSaved || thumbnail; else elseTemplate">
                                    <img class="release-note-thumbnails" width="100%" height="240" [src]="thumbnail"/>
                                </ng-container>
                                <ng-template #elseTemplate>
                                    <i class="fal fa-bell-on release-note-icon"></i>
                                </ng-template>
                                <div class="img-space--button hidden">
                                    <small class="">{{ 'Max file size: 2MB. Recommend format: jpg, jpeg and png' |
                                        translate }}
                                    </small>
                                </div>
                            </div>
                        </div>
                        <div class="col-xs-8 releaseNote-form--content">

                            <input type="hidden" formControlName="id">
                            <div *ngIf="successMessage" class="row form-group" role="alert">
                                <div class="col-sm-12">
                                    <div class="alert alert-info">
                                        {{ successMessage | translate }}
                                    </div>
                                </div>
                            </div>
                            <div *ngIf="errorMessage?.length" class="row form-group" role="alert">
                                <div class="col-sm-10">
                                    <div class="alert alert-danger">
                                        <div *ngFor="let error of errorMessage">
                                            <i class="fas fa-exclamation-circle" aria-hidden="true"></i>
                                            {{  error | translate}}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="form-group col-xs-12">
                                    <span *ngIf="releaseNote && releaseNote['language_flag']">
                                        <img [src]="releaseNote['language_flag']">
                                    </span>
                                </div>
                            </div>
                            <div class="row">
                                <div class="form-group col-xs-12">
                                    <label for="title">{{ 'Release Version' | translate }} *</label>
                                    <input type="text" class="form-control" id="version" formControlName="version">
                                    <small class="form-text text-danger" [hidden]="form.controls.version.valid ||
                                                                           (form.controls.version.pristine &&
                                                                           !formSubmitted)">
                                        {{ 'Release Version is required.' | translate }}
                                    </small>
                                </div>
                            </div>

                            <div class="row">
                                <div class="form-group col-xs-12">
                                    <label for="title">{{ 'Release Note' | translate }}</label>
                                    <app-tinymce #releaseNoteDescription formControlName="description"
                                                 id="content"
                                                 [options]="
                                                            {
                                                            menubar: false,
                                                            toolbar: 'bold italic alignleft numlist bullist link formatselect | removeformat'
                                                            }"
                                    ></app-tinymce>
                                    <br>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-xs-12 text-xs-right">
                                    <button type="button" class="btn btn-secondary" (click)="hideModal()">
                                        {{ 'Cancel' | translate }}
                                    </button>
                                    <button type="submit" class="btn btn-primary">
                                        <span>{{ 'Save' | translate }}</span>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>
